<template>
  <div class="delete-page">
    <header class="delete-hero">
      <div class="hero-inner">
        <RouterLink to="/" class="back-link">← Nomade Digital</RouterLink>
        <p class="eyebrow">Conta</p>
        <h1>Excluir sua conta</h1>
        <p class="hero-copy">
          Saiba como solicitar a exclusão da sua conta e o que acontece com seus dados.
        </p>
      </div>
    </header>

    <main class="delete-shell">
      <article class="delete-card">
        <section class="delete-section">
          <h2>Como excluir sua conta</h2>
          <p>
            Você pode excluir sua conta diretamente no aplicativo Nomade Digital:
          </p>
          <ol>
            <li>Abra o app Nomade Digital no seu iPhone ou Android.</li>
            <li>Acesse <strong>Perfil → Configurações da Conta</strong>.</li>
            <li>Role até o final e toque em <strong>"Excluir conta"</strong>.</li>
            <li>Confirme a exclusão quando solicitado.</li>
          </ol>
          <p>
            A exclusão é permanente e não pode ser desfeita.
          </p>
        </section>

        <section class="delete-section">
          <h2>O que é excluído</h2>
          <p>Ao excluir sua conta, removemos permanentemente:</p>
          <ul>
            <li>Seu perfil e informações de conta (nome, e-mail, foto)</li>
            <li>Todas as suas jornadas, estadias e despesas</li>
            <li>Documentos e anexos enviados</li>
            <li>Posts e interações na timeline e comunidade</li>
            <li>Histórico de uso do Nômade IA</li>
            <li>Dados de assinatura Nômade Pro (a assinatura deve ser cancelada separadamente na App Store ou Google Play)</li>
          </ul>
        </section>

        <section class="delete-section">
          <h2>O que não é excluído automaticamente</h2>
          <p>
            Sua assinatura Nômade Pro (caso ativa) não é cancelada automaticamente pela exclusão da conta.
            Cancele sua assinatura antes de excluir a conta:
          </p>
          <ul>
            <li>
              <strong>iOS:</strong> Ajustes → Apple ID → Assinaturas → Nomade Digital
            </li>
            <li>
              <strong>Android:</strong> Google Play Store → Assinaturas → Nomade Digital
            </li>
          </ul>
        </section>

        <section class="delete-section">
          <h2>Prazo de remoção</h2>
          <p>
            Seus dados são removidos imediatamente após a confirmação da exclusão.
            Backups de sistema podem reter cópias por até 30 dias, após os quais são excluídos definitivamente.
          </p>
        </section>

        <section class="delete-section">
          <h2>Dúvidas ou problemas</h2>
          <p>
            Se não conseguir acessar o app ou precisar de ajuda para excluir sua conta,
            entre em contato pelo e-mail
            <a href="mailto:suporte@nomade-digital.com" class="link">suporte@nomade-digital.com</a>.
          </p>
        </section>

        <div class="legal-links">
          <RouterLink to="/privacy" class="link">Política de Privacidade</RouterLink>
          <span class="sep">·</span>
          <RouterLink to="/terms" class="link">Termos de Uso</RouterLink>
        </div>
      </article>
    </main>
  </div>
</template>

<script>
export default {
  name: 'DeleteAccountPage',
};
</script>

<style scoped>
.delete-page {
  min-height: 100vh;
  background:
    radial-gradient(circle at top left, rgba(79, 142, 247, 0.08), transparent 32%),
    linear-gradient(180deg, #0d1b2e 0%, #081526 100%);
  color: #e2eaf4;
  font-family: Inter, "Segoe UI", sans-serif;
}

.delete-hero {
  padding: 72px 20px 36px;
}

.hero-inner,
.delete-shell {
  max-width: 800px;
  margin: 0 auto;
}

.back-link {
  display: inline-flex;
  margin-bottom: 18px;
  color: #4f8ef7;
  text-decoration: none;
  font-weight: 600;
}

.eyebrow {
  margin: 0 0 12px;
  color: #34d399;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  font-size: 13px;
}

.delete-hero h1 {
  margin: 0 0 14px;
  font-size: clamp(32px, 5vw, 52px);
  line-height: 1.05;
}

.hero-copy {
  margin: 0;
  font-size: 18px;
  line-height: 1.6;
  color: #94adc8;
}

.delete-shell {
  padding: 0 20px 64px;
}

.delete-card {
  padding: 28px;
  border-radius: 28px;
  background: #152338;
  border: 1px solid #1e3352;
  box-shadow: 0 24px 60px -28px rgba(0, 0, 0, 0.4);
}

.delete-section + .delete-section {
  margin-top: 28px;
  padding-top: 28px;
  border-top: 1px solid #1e3352;
}

.delete-section h2 {
  margin: 0 0 12px;
  font-size: 22px;
}

.delete-section p,
.delete-section li {
  color: #94adc8;
  line-height: 1.72;
}

.delete-section p {
  margin: 0 0 12px;
}

.delete-section ol,
.delete-section ul {
  margin: 0 0 12px;
  padding-left: 20px;
}

.delete-section li {
  margin-bottom: 6px;
}

.delete-section strong {
  color: #e2eaf4;
}

.link {
  color: #4f8ef7;
  text-decoration: none;
}

.link:hover {
  text-decoration: underline;
}

.legal-links {
  margin-top: 28px;
  padding-top: 20px;
  border-top: 1px solid #1e3352;
  display: flex;
  gap: 8px;
  align-items: center;
  font-size: 13px;
}

.sep {
  color: #4a6080;
}

@media (max-width: 640px) {
  .delete-hero {
    padding-top: 48px;
  }

  .delete-card {
    padding: 20px;
    border-radius: 22px;
  }
}
</style>
